import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation changeCardSmsInfoStatus($cardId: ID!, $on: Boolean!) {
      smsInfoOn(cardId: $cardId) @include(if: $on) {
        success
      }
      smsInfoOff(cardId: $cardId) @skip(if: $on) {
        success
      }
    }
  `,
  config: {
    options: ({ cardId, on }) => ({
      variables: {
        cardId,
        on,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
    on: PropTypes.bool.isRequired,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/cards/changeCardSmsInfoStatus.js